import { getTrustYouProfilesFromResponse, getTrustYouReviewsFromResponse } from 'State/helpers/trustYou';

const trustYou = (state = {}, action = { type: null }) => {
    switch (action.type) {
        case 'GET_TRUST_YOU_PROFILE_REQUEST_START': {
            const { trustYouId, language } = action.payload;
            return {
                ...state,
                [trustYouId]: {
                    ...state[trustYouId],
                    profile: {
                        isLoading : true,
                        hasError  : false,
                        language,
                        data      : null,
                    },
                },
            };
        }
        case 'GET_TRUST_YOU_PROFILE_REQUEST_SUCCESS': {
            const { trustYouId, response } = action.payload;
            return {
                ...state,
                [trustYouId]: {
                    ...state[trustYouId],
                    profile: {
                        ...state[trustYouId].profile,
                        isLoading : false,
                        hasError  : false,
                        data      : getTrustYouProfilesFromResponse(response),
                    },
                },
            };
        }
        case 'GET_TRUST_YOU_PROFILE_REQUEST_FAILURE': {
            const { trustYouId } = action.payload;
            return {
                ...state,
                [trustYouId]: {
                    ...state[trustYouId],
                    profile: {
                        ...state[trustYouId].profile,
                        isLoading : false,
                        hasError  : true,
                        data      : null,
                    },
                },
            };
        }
        case 'GET_TRUST_YOU_REVIEWS_REQUEST_START': {
            const { trustYouId, language } = action.payload;
            return {
                ...state,
                [trustYouId]: {
                    ...state[trustYouId],
                    reviews: {
                        isLoading : true,
                        hasError  : false,
                        language,
                        data      : null,
                    },
                },
            };
        }
        case 'GET_TRUST_YOU_REVIEWS_REQUEST_SUCCESS': {
            const { trustYouId, response } = action.payload;
            return {
                ...state,
                [trustYouId]: {
                    ...state[trustYouId],
                    reviews: {
                        ...state[trustYouId].reviews,
                        isLoading : false,
                        hasError  : false,
                        data      : getTrustYouReviewsFromResponse(response),
                    },
                },
            };
        }
        case 'GET_TRUST_YOU_REVIEWS_REQUEST_FAILURE': {
            const { trustYouId } = action.payload;
            return {
                ...state,
                [trustYouId]: {
                    ...state[trustYouId],
                    reviews: {
                        ...state[trustYouId].reviews,
                        isLoading : false,
                        hasError  : true,
                        data      : null,
                    },
                },
            };
        }
        default:
            return state;
    }
};

export default trustYou;
